module.exports = __webpack_public_path__ + "img/EVX.08078526.svg";